
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/store-locations`,
        name: `${prefix}.accounts.store-locations.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.store-locations.index`,
                PageDescription: "Accounts master data: Store Locations",
            },
        },
    },

];
